import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from 'react-intl';

const Dollars = (props) => (
    <FormattedNumber value={props.amount} style='currency' currency='USD' />
);

Dollars.propTypes = {
    amount: PropTypes.number.isRequired,
};

export default Dollars;



// WEBPACK FOOTER //
// ./src/common/Dollars.js